import SiteTemplate from '@/templates/site-interno/SiteTemplate'
import Login from '@/pages/auth/Login'
import Teste from '@/components/Teste'
import Cadastro from '@/pages/auth/Cadastro'
import RecuperarSenha from '@/pages/auth/RecuperarSenha'
import AlterarSenha from '@/pages/auth/AlterarSenha'
import PrimeiroAcesso from '@/pages/auth/PrimeiroAcesso'
import HomeExterna from '@/pages/site/externa/Home'
import CaptchaExterno from '@/templates/site-externo/CaptchaExterno'
import CaptchaErro from '@/templates/site-externo/CaptchaErro'
import HomeInterna from '@/pages/site/interna/Home'
import Usuario from '@/pages/site/interna/administrador/usuarios/Usuarios'
import Captchas from '@/pages/site/interna/administrador/captchas/Captchas'
import CadastrarCaptcha from '@/pages/site/interna/administrador/captchas/CadastrarCaptcha'
import EditarCaptcha from '@/pages/site/interna/administrador/captchas/EditarCaptcha'
import UsuarioVisualizar from '@/pages/site/interna/administrador/usuarios/UsuarioVisualizar'
import UsuarioEditar from '@/pages/site/interna/administrador/usuarios/UsuarioEditar'
import UsuarioCadastrar from '@/pages/site/interna/administrador/usuarios/UsuarioCadastrar'
import MeuPerfil from '@/pages/site/interna/perfil/MeuPerfil'
import Permissoes from '@/pages/site/interna/administrador/permissoes/Permissoes'
import PermissaoCadastrar from '@/pages/site/interna/administrador/permissoes/PermissaoCadastrar'
import PermissaoEditar from '@/pages/site/interna/administrador/permissoes/PermissaoEditar'

const routes = [
  {
    path: '/',
    redirect: '/',
    name: 'Página Inicial',
    component: SiteTemplate,
    children: [
      {
        path: '/',
        component: HomeInterna
      },
      {
        path: '/usuarios',
        name: 'Usuários',
        component: Usuario
      },
      {
        path: '/captchas',
        name: 'Captchas',
        component: Captchas
      },
      {
        path: '/captcha/cadastrar',
        name: 'Cadastrar Captcha',
        component: CadastrarCaptcha
      },
      {
        path: '/captcha/:id/editar',
        name: 'Editar Captcha',
        component: EditarCaptcha
      },
      {
        path: '/usuario/:id/visualizar',
        name: 'Visualizar Usuário',
        component: UsuarioVisualizar
      },
      {
        path: '/usuario/:id/editar',
        name: 'Edição do Usuário',
        component: UsuarioEditar
      },
      {
        path: '/usuario/cadastrar',
        name: 'Cadastrar do Usuário',
        component: UsuarioCadastrar
      },
      {
        path: '/perfil',
        name: 'Meu Perfil',
        component: MeuPerfil
      },
      {
        path: 'perfis',
        name: 'Perfis',
        component: Permissoes
      },
      {
        path: 'perfil/cadastrar',
        name: 'Cadastrar Perfil',
        component: PermissaoCadastrar
      },
      {
        path: 'perfil/:id/editar',
        name: 'Editar Perfil',
        component: PermissaoEditar
      }
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/cadastro',
    component: Cadastro
  },
  {
    path: '/recuperar-senha',
    component: RecuperarSenha
  },
  {
    path: '/alterar-senha/:token',
    component: AlterarSenha
  },
  {
    path: '/primeiro-acesso',
    component: PrimeiroAcesso
  },
  {
    path: '/acesso',
    name: 'Área Externa',
    component: HomeExterna
  },
  {
    path: '/captcha-externa',
    name: 'Captcha Externa',
    component: CaptchaExterno
  },
  {
    path: '/captcha-erro',
    name: 'Captcha Externa Erro',
    component: CaptchaErro
  },
  {
    path: '/ezequiel',
    name: 'Área Externasdfsd',
    component: Teste
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js